import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from '@sdvor/shared/ui';
import { SdSeoTextComponent } from './seo-text.component';

@NgModule({
  declarations: [SdSeoTextComponent],
  imports: [NgIf, AsyncPipe, SafeHtmlPipe],
  exports: [SdSeoTextComponent],
})
export class SdSeoTextModule {}
